export function SelectedCellManager(selector) {
	var TABLE_SELECTOR = '#' + selector;
	var selectedCell = null;
	var selectedRowIndex = 0;
	var selectedCellIndex = 0;

	this.setSelectedCell = function(cell) {
		if (cell[0].tagName === 'TR')
			selectedCell = cell.prevObject;
		else
			selectedCell = cell;
	};

	this.needSave = function () {
		if (selectedCell == null || _.isEmpty(selectedCell)) return false;
		else return true;
	};

	this.getSelectionsConfig = function () {
		var config = {};
		config.selectedCellIndex = selectedCell.index() + 1;
		config.selectedRowIndex = parseInt(selectedCell.parent().attr("data-index"));
		return config;
	};

	this.setSelectionsConfig = function (config) {
		selectedCell = {};
		selectedRowIndex = config.selectedRowIndex;
		selectedCellIndex = config.selectedCellIndex;
	};

	this.selectCell = function () {
		var row = $(TABLE_SELECTOR + " tbody").children().eq(selectedRowIndex);
		var cell = row.children().eq(selectedCellIndex);
		cell.focus();
		selectedCell = cell;
		selectedRowIndex = 0;
		selectedCellIndex = 0;
	};

	this.makeMovable = function () {
		$(TABLE_SELECTOR).unbind("keydown", handler);
		$(TABLE_SELECTOR + " tr td").not('.bs-checkbox').attr("tabindex", "1");
		$(TABLE_SELECTOR).bind("keydown", handler);
	};

	function handler(e) {
		switch (e.which) {
		case 13: // enter
			selectedCell.mousedown().parent().dblclick();
			break;
		case 37: // left
			moveToLeft($(e.target));
			break;
		case 38: // up
			moveToUp($(e.target));
			break;
		case 39: // right
			moveToRight($(e.target));
			break;
		case 40: // down
			moveToDown($(e.target));
			break;
		case 9: // tab
			moveToRight($(e.target));
			break;
		default:
			return;
		}
		e.preventDefault();
	}

	function moveToLeft() {
		if (selectedCell.prev()[0]) {
			selectedCell = selectedCell.prev();
			selectedCell.focus();
		}
	};

	function moveToRight() {
		if (selectedCell.next()[0]) {
			selectedCell = selectedCell.next();
			selectedCell.focus();
		}
	};

	function moveToUp() {
		var cellIndex = selectedCell.index();
		if (selectedCell.parent().prev()[0]) {
			selectedCell = selectedCell.parent().prev().children().eq(cellIndex);

			if (selectedCell.length > 0) {
				if (selectedCell[0].getBoundingClientRect().y < 60) {
					$(document).scrollTop(selectedCell[0].getBoundingClientRect().y);
				}
			}

			selectedCell.focus();
		}
	};

	function moveToDown() {
		var cellIndex = selectedCell.index();
		if (selectedCell.parent().next()[0]) {
			selectedCell = selectedCell.parent().next().children().eq(cellIndex);
			selectedCell.focus();
		}
	};
}
